/** 단일 시간 구간 — UI에서는 ISO 문자열, API에서는 'HH:mm' */
export type TimeSlot = {
    /** ISO 문자열 또는 빈 문자열 */
    startTime: string;
    /** ISO 문자열 또는 빈 문자열. 다음날 00:00 = 그날의 끝(24:00) */
    endTime: string;
};

export type DaySchedule = {
    enabled: boolean;
    /** 다중 시간 구간. 비활성 요일이면 빈 배열 */
    timeSlots: TimeSlot[];
};

export type WeekSchedule = {
    월: DaySchedule;
    화: DaySchedule;
    수: DaySchedule;
    목: DaySchedule;
    금: DaySchedule;
    토: DaySchedule;
    일: DaySchedule;
};

export type ExceptionInclude = {
    id: string;
    date: string;
    startTime: string;
    endTime: string;
    memo?: string;
    isSaved?: boolean;
    isMemoEditing?: boolean;
};

export type ExceptionExclude = {
    id: string;
    date: string;
    memo?: string;
    isSaved?: boolean;
    isMemoEditing?: boolean;
};

export const DAYS = ['월', '화', '수', '목', '금', '토', '일'] as const;

/** 통합 근무 입력 탭 — 셀 상태 */
export type CellState =
    | { type: 'default-on' } // 기본 근무 요일
    | { type: 'default-off' } // 요일상 휴무
    | { type: 'include'; startTime: string; endTime: string; memo?: string } // IN (추가근무)
    | { type: 'exclude'; memo?: string }; // OUT (근무제외)

/** 통합 근무 입력 탭 — 브러시 */
export type BrushType =
    | { kind: 'default' } // 기본 근무로 복원 (exceptions 제거)
    | { kind: 'exclude'; memo?: string } // 휴무
    | { kind: 'include'; startTime?: string; endTime?: string; memo?: string }; // 추가근무 (시간은 드래그 종료 후 입력)

/** 저장된 템플릿 (v2) */
export interface WorkTemplate {
    id: string;
    name: string;
    type: 'include' | 'exclude';
    startTime?: string;
    endTime?: string;
    memo?: string;
}
